export const segmentZones = {
  264291: 'Destination',
  258620: 'MidFeed',
  264289: 'Organic',
  257152: 'Nearby',
  264290: 'Featured',
  280648: 'FeedOtherZone',
  281190: 'ParentCenterLocations',
  281186: 'TaxNearby',
  281077: 'Similar',
  281220: 'Local'
}

export const ZONE_IDS_LIST = {
  Nationwide: 'Nationwide',
  Explore: 'Explore'
}
